import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "card-header pe-5",
  id: "kt_drawer_chat_messenger_header"
}
const _hoisted_2 = { class: "card-title fs-5" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary",
  id: "kt_drawer_chat_close"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2x" }
const _hoisted_6 = {
  class: "card-body",
  id: "kt_drawer_chat_messenger_body"
}
const _hoisted_7 = { class: "timeline-item" }
const _hoisted_8 = {
  key: 0,
  class: "overflow-auto pb-5"
}
const _hoisted_9 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed flex-shrink-0 p-6" }
const _hoisted_10 = { class: "d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap" }
const _hoisted_11 = { class: "mb-3 mb-md-0 fw-bold" }
const _hoisted_12 = { class: "text-gray-800 fw-bolder" }
const _hoisted_13 = { class: "d-flex mb-8" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px bg-success" }, null, -1)
const _hoisted_15 = { class: "flex-grow-1 mx-3" }
const _hoisted_16 = {
  href: "Javascript:;",
  class: "text-gray-800 text-hover-primary fw-bolder fs-6"
}
const _hoisted_17 = { class: "text-muted fw-bold d-block" }
const _hoisted_18 = { class: "d-flex align-items-center mb-8" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px bg-success" }, null, -1)
const _hoisted_20 = { class: "flex-grow-1 mx-3" }
const _hoisted_21 = {
  href: "Javascript:;",
  class: "text-gray-800 text-hover-primary fw-bolder fs-6"
}
const _hoisted_22 = { class: "text-muted fw-bold d-block" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px bg-success" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid mx-5" }, null, -1)
const _hoisted_26 = { class: "flex-grow-1" }
const _hoisted_27 = {
  href: "Javascript:;",
  class: "text-gray-800 text-hover-primary fw-bolder fs-6"
}
const _hoisted_28 = { class: "text-muted fw-bold d-block" }
const _hoisted_29 = {
  key: 0,
  class: "badge badge-light-success fs-6 fw-bolder"
}
const _hoisted_30 = {
  key: 1,
  class: "badge badge-light-danger fs-6 fw-bolder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.translate("courseAttendance.stdAbsence")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.courseAbsenceDetailsRes)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.translate("stdData")), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.courseAbsenceDetailsRes?.fullName), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.courseAbsenceDetailsRes?.studFacultyCode), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.courseAbsenceDetailsRes?.courseDescr), 1),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.courseAbsenceDetailsRes?.edCourseCode), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (
            _ctx.courseAbsenceDetailsRes &&
            _ctx.courseAbsenceDetailsRes.coursesAbsenceDetails.length > 0
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseAbsenceDetailsRes.coursesAbsenceDetails, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex align-items-center mb-8"
                }, [
                  _hoisted_24,
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("a", _hoisted_27, _toDisplayString(item.edCdeTeachingMethod), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formattedDate(item?.absDate) || "--"), 1)
                  ]),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.translate("courseAttendance.excuse")) + " : ", 1),
                    (item.execuseFlg)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.translate("yes")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.translate("no")), 1))
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}